import React, { useState, useEffect } from 'react';
import { format, isToday } from 'date-fns';
import './DayCell.css';

const DayCell = ({ day, tasks, onAddTask, onTaskClick }) => {
    const { date, isCurrentMonth } = day;
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (!date) {
        return <div className="day-cell-empty" />;
    }

    const isCurrentDay = isToday(date);
    const maxTasks = isMobile ? 2 : 3; // Show 2 tasks on mobile, 3 on desktop
    const tasksToShow = tasks.slice(0, maxTasks);
    const remainingCount = tasks.length - tasksToShow.length;

    // Enhanced color coding for tasks with priority indicators
    const getTaskColor = (task) => {
        const colors = {
            high: 'task-high',
            medium: 'task-medium',
            low: 'task-low',
            default: 'task-default'
        };
        return colors[task.priority] || colors.default;
    };

    return (
        <div
            className={`day-cell ${!isCurrentMonth ? 'not-current-month' : ''}`}
        >
            {/* Date number */}
            <div className="day-header">
                <span
                    className={`date-number ${isCurrentDay
                        ? 'current-day'
                        : isCurrentMonth
                            ? 'current-month'
                            : 'not-current-month'
                        }`}
                >
                    {format(date, 'd')}
                </span>

                {/* Add task button */}
                <button
                    onClick={() => onAddTask(date)}
                    className="add-task-btn"
                    aria-label={`Add task for ${format(date, 'MMMM d, yyyy')}`}
                    title="Add task"
                >
                    <svg className="add-task-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                </button>
            </div>

            {/* Tasks */}
            <div className="tasks-container">
                {tasksToShow.map((task) => (
                    <button
                        key={task.id}
                        onClick={() => onTaskClick(task)}
                        className={`task-item ${getTaskColor(task)}`}
                        title={task.task}
                    >
                        <div className="task-text">{task.task}</div>
                        {task.owner && (
                            <div className="task-owner">{typeof task.owner === 'object' ? task.owner.name : task.owner}</div>
                        )}
                    </button>
                ))}

                {remainingCount > 0 && (
                    <div className="more-tasks">
                        <div className="more-dot"></div>
                        <span className="more-text">
                            <span className="desktop">+{remainingCount} more</span>
                            <span className="mobile">+{remainingCount}</span>
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DayCell;